import React from 'react';
import './seo-content.scss';

const CITY_TEST = [
    'los-angeles-ca',
    'wenatchee-wa',
    'flagstaff-az',
    'phoenix-az',
    'columbus-oh',
    'jacksonville-nc',
    'oceanside-ca',
    'charlotte-nc',
    'san-antonio-tx',
    'philadelphia-pa',
    'san-francisco-ca',
    'albuquerque-nm',
    'jacksonville-fl',
    'fort-collins-co',
    'colorado-springs-co',
    'grand-rapids-mi',
    'columbus-oh',
    'orlando-fl',
    'madison-wi',
    'fort-myers-fl',
    'indianapolis-in',
    'milwaukee-wi',
    'brooklyn-ny',
    'st-louis-mo',
    'san-jose-ca',
    'minneapolis-mn',
    'wilmington-nc',
    'nashville-tn',
    'cincinnati-oh',
    'thornton-co',
    'miami-fl',
    'boise-id',
    'port-st-lucie-fl',
    'albany-ny',
    'aiken-sc',
    'myrtle-beach-sc',
    'mesa-az',
    'lubbock-tx',
    'fort-wayne-in',
    'chandler-az',
    'appleton-wi',
    'abilene-tx',
    'tampa-fl',
    'raleigh-nc',
    'tacoma-wa',
    'greenville-sc',
    'stockton-ca',
    'springfield-or',
    'columbia-mo',
    'pembroke-pines-fl',
];

const SeoContent = ({ city }) => {
    if (!CITY_TEST.includes(city.url)) {
        return '';
    }

    return (
        <div className="sniff-seo-content">
            <div className="l-container">
                <div dangerouslySetInnerHTML={{ __html: city.seoContent }} />
            </div>
        </div>
    );
};

export default SeoContent;
